// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const ErrorMessage = props => props.isValid ?
    null :
    <span className='error-message'>
        <FormattedMessage id={props.errorMessage}/>
    </span>;

ErrorMessage.displayName = 'ErrorMessage';
ErrorMessage.propTypes = {
    errorMessage: PropTypes.string.isRequired,
    isValid: PropTypes.bool.isRequired
};

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/shared/components/error-message/index.js